<template>
  <div class="">
    <div class="q_pad_lr15px">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item>
          <van-image width="100%" fit="cover" :src="require('@/assets/image/exch.png')"/>
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功" v-if="!showEmpty">
      <van-list
          v-model:loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          error-text="请求失败，点击重新加载"
      >
        <div class="q_mar_l15px q_mar_r1px">
          <div class="q_store" @click="goToExchangdea(item.id)" :key="item.id" v-for="item in list">
            <van-image fit="cover" :src="convertImg(item.pic)"/>
            <div class="q_text_m q_bold q_moit1 q_mar_t5px">{{ item.name }}</div>
            <div class="q_text_m q_bold q_color_red q_mar_t5px">{{ item.integral }}积分</div>
          </div>
          <!--			<div class="q_store" @click="goToExchangdea()">-->
          <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
          <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
          <!--				<div class="q_text_m q_bold q_color_red q_mar_t5px">32积分</div>-->
          <!--			</div>-->
          <!--			<div class="q_store" @click="goToExchangdea()">-->
          <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
          <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
          <!--				<div class="q_text_m q_bold q_color_red q_mar_t5px">32积分</div>-->
          <!--			</div>-->
          <!--			<div class="q_store" @click="goToExchangdea()">-->
          <!--				<van-image fit="cover" :src="require('../../assets/image/act.png')" />-->
          <!--				<div class="q_text_m q_bold q_moit1 q_mar_t5px">商品名称商品名称商品名称商品名称</div>-->
          <!--				<div class="q_text_m q_bold q_color_red q_mar_t5px">32积分</div>-->
          <!--			</div>-->
        </div>
      </van-list>
    </van-pull-refresh>
    <!--空数据-->
    <div class="q_center" style="margin-top: 26vh;" v-if="showEmpty">
      <img src="@/assets/image/none.png" style="width: 26vw;"/>
      <p class="q_color_gray q_text_s q_mar_t20px">暂无信息</p>
    </div>
  </div>
</template>

<script>
import {listGoods} from "@/api/goods";

export default {
  name: 'Exchange',
  props: {
    msg: String
  },
  data() {
    return {
      showEmpty: false,
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      pageParam: {
        pageNum: 0,
        pageSize: 6,
      }
    }
  },
  created() {
  },
  methods: {
    /**
     * 下拉刷新
     */
    onRefresh() {
      this.pageParam = {
        pageNum: 0,
        pageSize: 6,
      }
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    /**
     * 下滑加载更多
     */
    onLoad() {
      this.pageParam.pageNum++
      if (this.pageParam.pageNum == 1) {
        this.$modal.loading()
      }
      //查询商品信息列表
      listGoods(this.pageParam).then(res => {
        if (res.total == 0) {
          this.showEmpty = true
        }
        //是否下拉刷新
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }
        console.log('res', res)
        for (let i = 0; i < res.rows.length; i++) {
          this.list.push(res.rows[i]);
        }

        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    goToExchangdea(id) {
      this.$router.push({
        path: '/home/Exchangdea', query: {id: id}
      });
    },
  }
}
</script>
<style scoped="scoped">
>>> .my-swipe {
  margin: 15px 0;
}

>>> .my-swipe .van-image {
  height: 100px;
}

>>> .my-swipe .van-image__img {
  border-radius: 5px;
}

.q_store {
  display: inline-block;
  width: 50%;
  margin-bottom: 15px;
}

.q_store >>> .van-image__img {
  width: 165.5px;
  height: 165.5px;
  border-radius: 5px;
}
</style>
